import React from 'react';
// import {Link} from 'react-router-dom'
import { Chart } from "react-google-charts";
import GoogleFontLoader from 'react-google-font-loader';
import { Timeline, TimelineItem }  from 'vertical-timeline-component-for-react';
import { PieChart } from 'react-minimal-pie-chart';

import './App.css';
import Header from './Header';
import Footer from './Footer';
import Navigation from './Nav';


import { FaLocationArrow,FaMotorcycle,FaConnectdevelop, 
         FaPagelines, FaBook, FaFilm , FaArrowCircleUp
} from 'react-icons/fa';
import { Jumbotron, Row, Col, Container, CardImg, Button
} from 'reactstrap';

         

function Formations() {


    return(

        <div id="pageUp">
            <Header />
            <Navigation />          

{/* GOOGLE FONTS -------------------------------------------------------------*/}       
            <GoogleFontLoader
            fonts={[
              {
                font: 'Roboto',
                weights: [400, '400i'],
              },
              {
                font: 'Roboto Condensed',
                weights: [400, 700],
              },
              {
                  font: 'Titillium Web',
                  weights: [400, 700],
                },
                {
                  font: 'Poppins',
                  weights: [400, 700],
                },
            ]}
            subsets={['cyrillic-ext', 'greek']}
             />
              
{/* A PROPOS ----------------------------------------------------- */}
    <Row>
        <Col md='3'
        style={{ animationName:'example', 
                 animationDuration:'20s',
                backgroundColor:'#34b6bc', 
                borderBottomRightRadius:'80%',
                borderTopRightRadius:'5%'
                }}>

        <h2 style={{marginTop:'20px', marginLeft:'20px', color:'black'}}>Mon CV</h2>

        <h2 style={{fontSize:'25px', fontFamily: 'Roboto Condensed', fontWeight:'bold',
                     marginTop:'20px', 
                     marginBottom:'10px',
                     marginLeft:'20px'
                     }}>
            À propos</h2>
        <p style={{fontSize:'13px', 
                  fontFamily:'Poppins',
                  marginLeft:'20px', marginRight:'20px'
                  }}>
            Suite à une reconversion professionnelle, j'ai souhaité me diriger 
            vers le domaine qui me passionne depuis longtemps : le développement mobile et web.</p>
        
        <p style={{fontSize:'13px', 
                  fontFamily:'Poppins',
                  marginLeft:'20px', marginRight:'30px'
                  }}>
            J'ai donc suivi une formation de développeur mobile iOS chez "OpenClassrooms" ainsi qu'un 
            cursus de développeur web et mobile full stack Javascript chez "La Capsule". Je complète aussi 
            ma formation en suivant des cours sur "Udemy" et "Purple Girafe".
            </p>

        <p style={{fontSize:'13px', 
                  fontFamily:'Poppins',
                  marginLeft:'20px', marginRight:'30px'
                  }}>N'hésitez pas à me contacter.</p>

        <p style={{
          fontFamily:'Poppins',
          fontWeight:'bold',
          marginTop:'30px'
        }}><FaLocationArrow 
        size={10} color={'black'} style={{marginLeft:'30px', marginRight:'10px'}}/>
        Paris et île-de-France</p>

        <p style={{
          fontFamily:'Poppins',
          fontWeight:'bold',
        }}><FaMotorcycle 
        size={20} color={'black'} style={{marginLeft:'30px', marginRight:'10px'}}/>
        Permis A2 et B</p>
        
        </Col>
       
{/* GRAPHIQUES -------------------------------------------------------------*/}
        <Col md='5' 
        style={{marginTop:'10px', marginLeft:'10px'}} >
     
        <FaConnectdevelop size={60} color={'#34b6bc'}/>
     
        <h1 style={{fontSize:'25px', fontFamily: 'Roboto Condensed', fontWeight:'bold',
        marginTop:'20px', marginBottom:'0px'}}>
            Compétences techniques</h1>

        <p style={{fontSize:'', marginBottom:'0px', marginTop:'5px'}}>Développement iOS & Web</p>

        {/* GRAPHIQUES  iOS -------------------------------------------------------------*/}
        <Chart style={{fontWeight:'bold'}}
        // width={'500px'}
        // height={'300px'}
        chartType="BarChart"
        loader={<div>Loading Chart</div>}
        data={[
            [
            'Element',
            '',
            { role: 'style' },
            {
                sourceColumn: 0,
                role: 'annotation',
                type: 'string',
                calc: 'stringify',
            },
            ],
            ['Swift', 90, '#ea6515', null],
            ['User default', 89, '#ea6515', null],
            ['Core Data', 89, '#ea6515', null],
            ['tests', 88, 'color: #ea6515', null],
            ['Lisibilité du code', 90, 'color: #f3dc1a', null],
            ['Responsive', 90, 'color: #f39f1a', null],
            ['API', 89, 'color: #f39f1a', null],
        ]}
        options={{
            title:'Développement iOS',
            width: 500,
            height: 300,
            bar: { groupWidth: '30%' },
            legend: { position: 'none' },
            fontSize: 12,

        }}
        // For tests
        rootProps={{ 'data-testid': '6' }}
        />

        {/* GRAPHIQUES Web-------------------------------------------------------------*/}
        <Chart style={{fontWeight:'bold'}}
        // width={'500px'}
        // height={'300px'}
        chartType="BarChart"
        loader={<div>Loading Chart</div>}
        data={[
            [
            'Element',
            '',
            { role: 'style' },
            {
                sourceColumn: 0,
                role: 'annotation',
                type: 'string',
                calc: 'stringify',
            },
            ],
            ['HTML, CSS', 90, '#50a0fb', null],
            ['ExpressJS', 89, '#50a0fb', null],
            ['React, React RouterDom', 90, '50a0fb', null],
            ['React Native', 89, '#50edfb', null],
            ['SQL', 89, 'color: #8450fb', null],
            ['MongoDB', 90, 'color: #8450fb', null],
            ['Responsive', 90, 'color: #50a8fb', null],
            ['API', 88, 'color: #50a8fb', null],
        ]}
        options={{
            title:'Développement web & mobile (multi-plateforme)',
            width: 500,
            height: 350,
            bar: { groupWidth: '30%' },
            legend: { position: 'none' },
            fontSize: 12,
            

        }}
        // For tests
        rootProps={{ 'data-testid': '6' }}
        />

        </Col>

{/* TITRE outils techniques ----------------------------------------*/}
        
        <Col md='3'
        style={{marginTop:'20px'}} >

        <h1 style={{fontSize:'25px', fontFamily: 'Roboto Condensed', fontWeight:'bold',
                    marginLeft:'10px' }}>
                     Outils techniques</h1>
        {/* LIGNE --------------------------------------------------------------------*/}
        <div style={{height:'1px', width:'100%', marginBottom:'10px', backgroundColor:'#7a7a7a'}}></div>

        {/* OUTILS TECHINQUES ----------------------------------------*/}  
        <Row style={{marginLeft:'10px'}}>
        <CardImg style={{width:'12%',height:'12%'}} 
                 src="/images/formations/xcode.jpg" alt="Card image cap"/>
        <p style={{marginTop:'10px', marginLeft:'10px', fontSize:'12px'}}>Xcode</p>
        </Row>

        <Row style={{marginLeft:'10px'}}>
        <CardImg style={{width:'12%',height:'12%'}} 
                 src="/images/formations/visualStudioCode.jpg" alt="Card image cap"/>
        <p style={{marginTop:'10px', marginLeft:'10px', fontSize:'12px'}}>Visual studio code</p>
        </Row>

        <Row style={{marginLeft:'10px'}}>
        <CardImg style={{width:'12%',height:'12%'}} 
                 src="/images/formations/git.png" alt="Card image cap"/>
        <p style={{marginTop:'10px', marginLeft:'10px', fontSize:'12px'}}>Git</p>
        </Row>

        <Row style={{marginLeft:'10px'}}>
        <CardImg style={{width:'12%',height:'12%', marginTop:'5px'}} 
                 src="/images/formations/githubDesktop.png" alt="Card image cap"/>
        <p style={{marginTop:'10px', marginLeft:'10px', fontSize:'12px'}}>Github desktop</p>
        </Row>

{/* Titre Langues ----------------------------------------*/}
        <h1 style={{fontSize:'25px', fontFamily: 'Roboto Condensed', fontWeight:'bold', 
                    marginTop:'50px', marginLeft:'10px'}}>
                     Langues</h1>
       
        {/* LIGNE --------------------------------------------------------------------*/}
        <div style={{height:'1px', width:'100%', marginBottom:'10px', backgroundColor:'#7a7a7a'}}></div>
        {/* Titre Langues ----------------------------------------*/}
        <Row style={{marginTop:'20px', marginLeft:'10px'}}>
        <Col>
        <PieChart style={{marginBottom:'0px'}}
        animate={true}
        viewBoxSize={[100, 100]}

          data={[
            { title: 'Anglais', value: 60, color: '#50fb94' },
            { title: 'Espagnol', value: 40, color: '#50ddfb' },
            
          ]}
        />
       </Col>

       <Col>
        <CardImg style={{width:'10%',height:'10%', marginTop:'0px'}} 
                 src="/images/formations/anglais.png" alt="Card image cap"/>
        <p style={{fontSize:'12px'}}>Anglais</p>
      
        <CardImg style={{width:'10%',height:'10%', marginTop:'0px'}} 
                 src="/images/formations/espagnol.png" alt="Card image cap"/>
        <p style={{fontSize:'12px'}}>Espagnol</p>
        </Col>
        </Row>

{/* Titre Loisirs ----------------------------------------*/}
        <h1 style={{fontSize:'25px', fontFamily: 'Roboto Condensed', fontWeight:'bold', 
                    marginTop:'50px', marginLeft:'10px'}}>
                     Loisirs</h1>
       
        {/* LIGNE --------------------------------------------------------------------*/}
        <div style={{height:'1px', width:'100%', marginBottom:'10px', backgroundColor:'#7a7a7a'}}></div>
        <Row style={{marginTop:'20px'}}>
        <Col className='text-center'>
        <FaPagelines size={40} color={'#34b6bc'}/>
        <p style={{fontSize:'12px', marginTop:'5px'}}>Permaculture</p>
        </Col>

        <Col className='text-center'>
        <FaBook size={40} color={'#34b6bc'}/>
        <p style={{fontSize:'12px', marginTop:'5px'}}>Lecture</p>
        </Col>

        <Col className='text-center'>
        <FaFilm size={40} color={'#34b6bc'}/>
        <p style={{fontSize:'12px', marginTop:'5px'}}>Cinéma</p>
        </Col>
        </Row>

{/* Fin troisième colonne --------------------------------------------------------*/}
        </Col>
        </Row>  

       

{/* EXPERIENCES -------------------------------------------------------------- */}
        <Jumbotron style={{backgroundColor:'#f5f5f5', marginTop:'10px', paddingTop:'0px'}}>
        <Container>
        <Row>
{/* TITRE Expériences Professionnelles-------------------------------------- */}       
    <Col md='12'
    style={{marginTop:'20px'}}>
    <h1 style={{fontSize:'25px', fontFamily: 'Roboto Condensed', fontWeight:'bold',
                marginTop:'20px', marginBottom:'0px'}}>
    Expériences professionnelles</h1>
    </Col>


    {/* LIGNE --------------------------------------------------------------------*/}
    <div style={{height:'1px', width:'100%', marginBottom:'10px', backgroundColor:'#7a7a7a'}}></div>

{/* TImeLine Expériences Professionnelles-------------------------------------- */}
 <Timeline lineColor={'#ddd'}>
  <TimelineItem
    key="001"
    dateText="Janvier 2020 – mars 2020"
    dateInnerStyle={{ fontSize:'12px', background:'#50a0fb'}}
    style={{ color: '#50a0fb' }}
  >
    <h3 style={{fontSize:'20px'}}>OrdR - Projet étudiant - Paris</h3>
    <h1 style={{fontSize:'25px', marginTop:'10px', marginBottom:'20px'}}>Développeur d'application mobile et web</h1>
    <p style={{fontFamily:'Poppins'}}>
      OrdR est une application mobile destinée à la restauration. Elle permet de simplifier
      le processus de prise de commande en scannant un QRCode. </p>
      <ul style={{fontFamily:'Poppins'}}>
          <li>Conception des mockups de la UI</li>
          <li>Chargée du développement de l'application mobile avec React Native</li>
      </ul>
   

  </TimelineItem>
  <TimelineItem
    key="002"
    dateText="Novembre 2019 – Décembre 2019"
    dateInnerStyle={{ background: '#ea6515', color: 'white', fontSize:'12px'}}
    style={{color:'#ea6515'}}
    bodyContainerStyle={{
      background: '#ddd',
      padding: '20px',
      borderRadius: '8px',
      boxShadow: '0.5rem 0.5rem 2rem 0 rgba(0, 0, 0, 0.2)',
    }}
  >
    <h3 style={{fontSize:'20px'}}>TRinder - Projet étudiant - Montreuil</h3>
    <h1 style={{ marginTop:'10px', marginBottom:'10px', fontSize:'25px' }}>Développeur d'application iOS</h1>
    <p style={{fontFamily:'Poppins'}}>TRinder est une application mobile destinée à informer tous les utilisateurs
        sur leur manière de trier leurs déchets, de manière ludique grâce à un jeu et 
        à une aide mémoire.
    </p>
      <ul style={{fontFamily:'Poppins'}}>
          <li>Maquette de l'application
          </li>
          <li>Développement de l'interface multi-écran</li>
          <li>Développement avec MVC</li>
           <li>Intégration de MapKit</li>
      </ul>
  

  </TimelineItem>
  </Timeline>

{/* TITRE Formation -------------------------------------- */}
  <Col md='12'
            style={{marginTop:'0px'}}>
            <h1 style={{fontSize:'25px', fontFamily: 'Roboto Condensed', fontWeight:'bold',
                        marginTop:'20px', marginBottom:'0px'}}>
            Formation</h1>
  </Col>

  {/* LIGNE --------------------------------------------------------------------*/}
  <div style={{height:'1px', width:'100%', marginBottom:'10px', backgroundColor:'#7a7a7a'}}></div>

{/* TimeLine Formation -------------------------------------- */}
  <Timeline lineColor={'#ddd'}>
   <TimelineItem
    key="001"
    dateText="Août 2018 – Aujourd'hui"
    dateInnerStyle={{background:'#ea6515', color: 'white', fontSize:'12px'}}
    style={{ color: '#ea6515' }}
  >
    <h3 style={{fontSize:'20px'}}>OpenClassrooms</h3>
    <h1 style={{marginTop:'10px', marginBottom:'10px', fontSize:'25px' }}>Développeur d'application iOS</h1>
    <ul style={{fontFamily:'Poppins'}}>
          <li>Développement de l'application mobile "Instagrid" de partage de photos
              via les réseaux sociaux et SMS
          </li>
          <li>Développement de l'application mobile d'une calculatrice
              "Count On Me" : Amélioration de l'application existante / 
              Intégration des tests unitaires
          </li>
          <li>Analyser les besoins d'un client / Lister les fonctionnalités
               demandées par un client / Rédiger les spécifications fonctionnelles
                / Proposer une solution technique adaptée</li>
           <li>Analyse logicielle avec UML - Méthode Agile</li>
      </ul>
  </TimelineItem>

  <TimelineItem
    key="002"
    dateText="Janvier 2020 – Mars 2020"
    dateInnerStyle={{ background:'#50a0fb', fontSize:'12px'}}
    style={{ color: '#50a0fb' }}
  >
    <h1 style={{fontSize:'20px'}}>La Capsule - Paris</h1>
    <h2 style={{marginTop:'10px', marginBottom:'10px', fontSize:'20px' }}>Développeur web et mobile Fullstack Javascript</h2>
    <ul style={{fontFamily:'Poppins'}}>
          <li>Site Web "Bike Shop" : expressJS et EJS en back-end / Requêtes HTTP /
              API Stripe / BDD avec MongoDB / Hébergement avec Héroku
          </li>
          <li>Site web "My Movies" : ReactJS / Librairie ReactStrap / Créer un
               composant React avec le JSX
          </li>
          <li>Site web "Morning News" : navigation avec React Router / Faire transiter 
              des informations complémentaires dans les routes / Intégrer un webservice
               de news : NewsAPI</li>
           <li>Application mobile "FaceUp" : React Native / React Native Element / 
               Expo / Intégrer un service tiers de gestion d'images (Cloudinary)
           </li>
      </ul>
  </TimelineItem>

  <TimelineItem
    key="002"
    dateText="Novembre 2019 – Décembre 2019"
    dateInnerStyle={{ fontSize:'12px', background:'#ea6515'}}
    style={{ color: '#ea6515' }}
  >
    <h1 style={{fontSize:'20px'}}>Simplon - Montreuil</h1>
    <h2 style={{marginTop:'10px', marginBottom:'10px', fontSize:'20px' }}>Développeur d'application iOS</h2>
    <ul style={{fontFamily:'Poppins'}}>
          <li>Identifier un besoin réel et mener une investigation du domaine
          </li>
          <li>Maquetter une application mobile avec Marvel
          </li>
          <li>Développer un prototype d'application mobile native iOS</li>
           <li>Collaborer et communiquer en équipe
           </li>
           <li>Présenter un projet de manière claire et captivante
           </li>
      </ul>
  </TimelineItem>
  </Timeline>
    
        </Row>

{/* RETOUR HAUT DE PAGE  ------------------------------------------------------- */}


<Col className='text-center'>
    <a href="#pageUp"name="pageUp" >
        <Button style={{backgroundColor:'#f5f5f5', borderWidth:'0px'}}>
      
        <FaArrowCircleUp 
            size={35} color={'#34b6bc'} 
            style={{backgroundColor:'white',
            borderRadius:'50%'
        }}/>
        </Button>
    </a>
    </Col>
    

    <Col className='text-center'>
    <p style={{marginTop:'20px', marginBottom:'100px',
                fontFamily:'Poppins'}}>Retour en Haut de la page</p>
    </Col>


        </Container>
        </Jumbotron>
        <Footer />
        </div>
    )
}

export default Formations;